'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Callout = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _enums = require('../enums');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Callout component.
 * http://foundation.zurb.com/sites/docs/callout.html
 *
 * @param {Object} props
 * @returns {Object}
 */
var Callout = exports.Callout = function Callout(props) {
  var className = (0, _utils.createClassName)(props.noDefaultClassName ? null : 'callout', props.className, props.color, props.size, (0, _utils.generalClassNames)(props));

  var passProps = (0, _utils.removeProps)(props, (0, _utils.objectKeys)(Callout.propTypes));

  return _react2.default.createElement('div', _extends({}, passProps, { className: className }));
};

Callout.propTypes = _extends({}, _utils.GeneralPropTypes, {
  color: _react.PropTypes.oneOf((0, _utils.objectValues)(_enums.CalloutColors)),
  size: _react.PropTypes.oneOf((0, _utils.objectValues)(_enums.CalloutSizes))
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-foundation/lib/components/callout.js
 ** module id = 1081
 ** module chunks = 0
 **/